<template>
  <mf-loading :loader="['get-campaigns']" loader-type="dialog">
    <v-container fluid class="pa-0">
      <v-card class="calendario">
        <v-card-text>
          <v-container fluid class="pa-0">
            <v-row>
              <filtro-campanhas :disabled="calendarLoading" />
              <mf-loading loader-type="dynamic" :boolean-loader="calendarLoading" :dynamic-amount="5" :dynamic-width="225">
                <v-sheet height="600" width="100%" class="mt-5">
                  <v-calendar
                    ref="calendar"
                    v-model="focus"
                    :events="events"
                    color=" primary"
                    :day-ripple="false"
                    :show-month-on-first="false"
                    :day-format="dayFormat"
                    :weekday-format="weekdayFormat"
                    :event-ripple="false"
                    locale="pt-BR"
                    :event-color="(event) => event.color"
                    @click.native="setMousePosition"
                    @click:event="showCampaign"
                    @click:more="showMore"
                  >
                    <template v-if="events.length" v-slot:event="{ event }">
                      <span v-if="event.status === 'FINISHED'" class="px-2">
                        <del>{{ event.name }}</del>
                      </span>
                      <span v-else class="px-2">{{ event.name }}</span>
                    </template>
                  </v-calendar>

                  <v-menu v-model="showMenu" :position-x="x" :position-y="y" absolute offset-y :close-on-content-click="false">
                    <v-card v-if="menuType === 'campaign'" class="card-campaign" width="370px">
                      <v-toolbar class="toolbar" elevation="0" :color="getCampaignColor(selectedCampaign.mode)" dark>
                        <v-toolbar-title>{{ getCampaignType(selectedCampaign.mode) }} </v-toolbar-title>
                        <v-spacer />
                        <mf-icon class="close-icon" color="branco" small @click="closeMenu">close</mf-icon>
                      </v-toolbar>
                      <v-card-text>
                        <p class="status">{{ getStatus(selectedCampaign.status) }}</p>
                        <p class="name">{{ selectedCampaign.title }}</p>
                        <p class="description">{{ selectedCampaign.description }}</p>

                        <div class="details">
                          <mf-icon class="mr-1" size="20">mail</mf-icon>
                          <span>Disparo: {{ DateTime.fromFormat(selectedCampaign.initial_date, 'yyyy-MM-dd').toFormat("d 'de' MMMM") }}</span>
                        </div>
                        <div class="details">
                          <mf-icon class="mr-1" fill size="20">event</mf-icon>
                          <span>{{ mensuracaoText({ initialDate: selectedCampaign.initial_date, finalDate: selectedCampaign.final_date }) }}</span>
                        </div>
                        <div class="details">
                          <mf-icon class="mr-1" fill size="20">group</mf-icon>
                          <span>{{
                            $tc(
                              'calendarioPromocional.quantidade_segmentos',
                              getSafe(() => selectedCampaign.segments.length || 0),
                              {
                                quantidade: getSafe(() => selectedCampaign.segments.length || 0),
                              }
                            )
                          }}</span>
                        </div>
                        <div class="details">
                          <mf-icon class="mr-1" size="20">sell</mf-icon>
                          <span
                            >{{
                              $tc(
                                'calendarioPromocional.quantidade_produtos',
                                getSafe(() => selectedCampaign.products_count || 0),
                                {
                                  quantidade: getSafe(() => selectedCampaign.products_count || 0),
                                }
                              )
                            }}
                          </span>
                        </div>
                        <div v-if="isMariaCampaign(selectedCampaign)" class="details">
                          <mf-icon class="mr-1" size="20" fill>chat</mf-icon>
                          <span>{{ getMariaCampaignChannels(selectedCampaign) }} </span>
                        </div>
                      </v-card-text>
                      <v-card-actions v-if="selectedCampaign.status === 'SCHEDULED'">
                        <mf-button text size="sm" label="Mais informações" @click="openRedirectDialog(selectedCampaign)" />
                      </v-card-actions>
                      <v-card-actions v-if="selectedCampaign.status === 'FINISHED'">
                        <mf-button text size="sm" label="Ver resultados da campanha" @click="openRedirectDialog(selectedCampaign)" />
                      </v-card-actions>
                    </v-card>

                    <v-card v-else class="card-more" width="300px">
                      <mf-icon class="close-icon" color="branco" small @click="closeMenu">close</mf-icon>
                      <v-card-text>
                        <p class="day-week">{{ clickedDay && clickedDay.weekdayShort.toUpperCase() }}</p>
                        <p class="day-number">
                          {{ clickedDay && clickedDay.toFormat('dd') }}
                        </p>

                        <div v-for="(event, index) in moreCampaigns" :key="index" class="campaign" @click="openCampaign(event)">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <div class="campaign" v-on="on">
                                <mf-icon class="mr-1" fill small :color="event.color">fiber_manual_record</mf-icon>
                                <span class="date-range">{{ formattedDateRange(event.start, event.end) }}</span>
                                <span class="name">{{ event.name }}</span>
                              </div>
                            </template>
                            <span>{{ event.name }}</span>
                          </v-tooltip>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-menu>
                </v-sheet>
              </mf-loading>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-container>
  </mf-loading>
</template>

<script>
import capitalize from 'lodash/capitalize'
import { mapState } from 'vuex'
import { QUERY_GET_GENERIC_CAMPAIGNS } from '@/modules/calendario-promocional/graphql'
import { DateTime } from 'luxon'
import { deepDelete } from '@/helpers/deepDelete'

export default {
  components: {
    FiltroCampanhas: () => import('@/modules/calendario-promocional/views/pages/CalendarioFiltroCampanhas.vue'),
  },
  data: () => ({
    showMenu: false,
    menuType: '',
    focus: '',
    x: 0,
    y: 0,
    selectedCampaign: {},
    moreCampaigns: [],
    clickedDay: '',
    firstRequestPending: true,
    DateTime: DateTime,
  }),

  computed: {
    ...mapState({
      currentMonth: (state) => state.calendarioPromocional.currentMonth,
      selectedModes: (state) => state.calendarioPromocional.selectedModes,
      isMariaSelected: (state) => state.calendarioPromocional.isMariaSelected,
    }),
    campaignTypes() {
      if (this.selectedModes.length && !this.isMariaSelected) return ['SINGLE_CHANNEL']
      else if (!this.selectedModes.length && this.isMariaSelected) return ['OMNI_CHANNEL']
      else return []
    },
    calendarLoading() {
      return this.firstRequestPending || this.$apollo.queries.campaigns.loading
    },
    events() {
      if (!Array.isArray(this.campaigns)) {
        return []
      }
      return this.campaigns.map((campaign) => {
        return {
          id: campaign._id,
          name: campaign.title,
          start: campaign.initial_date,
          end: campaign.final_date,
          color: this.getCampaignColor(campaign.mode),
          status: campaign.status,
          mode: this.selectedModes,
          type: 'campaign',
        }
      })
    },
  },
  apollo: {
    campaigns: {
      query: QUERY_GET_GENERIC_CAMPAIGNS,
      fetchPolicy: 'network-only',
      skip() {
        return !Object.entries(this.currentMonth).length
      },
      variables() {
        if (!Object.entries(this.currentMonth).length) {
          return {}
        }
        const curYear = this.currentMonth.year
        const curMonth = this.currentMonth.month

        return {
          channels: this.selectedModes.map((channel) => channel.toLowerCase()),
          status: ['ACTIVE', 'FINISHED'],
          measuringDate: [
            DateTime.fromObject({ year: curYear, month: curMonth, day: 1 }).toFormat('yyyy-MM-dd'),
            DateTime.fromObject({ year: curYear, month: curMonth, day: 1 }).plus({ months: 1, days: -1 }).toFormat('yyyy-MM-dd'),
          ],
          campaignTypes: this.campaignTypes,
          disableChannelsForOmniChannel: true,
          frequencyType: 'ONETIME',
        }
      },
      update({ genericCampaigns: { campaigns = [] } }) {
        this.firstRequestPending = false
        return campaigns
      },
      context() {
        return {
          uri: this.$microservicesUrls['campaigns'],
        }
      },
    },
  },
  watch: {
    currentMonth(curr, prev) {
      if (!curr || !prev || !this.$refs.calendar) {
        return
      }
      const diff = 12 * curr.year + curr.month - (12 * prev.year + prev.month)
      this.$refs.calendar.move(diff)
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    formatChannelName(channel) {
      if (channel === 'sms') return 'SMS'
      if (channel === 'whatsapp') return 'Whatsapp'
      if (channel === 'push') return 'Push aplicativo'
      if (channel === 'email') return 'E-mail'
    },
    isMariaCampaign(campaign) {
      return campaign.channels && !campaign.mode
    },
    getMariaCampaignChannels(selectedCampaign) {
      const { channels } = selectedCampaign
      const campaignChannels = []
      deepDelete(channels, '__typename')
      Object.entries(channels).forEach((channel) => (channel[1] ? campaignChannels.push(this.formatChannelName(channel[0])) : ''))
      if (campaignChannels.length === 1) return `Canal: ${campaignChannels[0]}`
      else return `Canais: ${campaignChannels.map((channel) => channel).join(', ')}`
    },
    getStatus(status) {
      if (!status) return '-'
      switch (status) {
        case 'DRAFT':
          return 'Rascunho'
        case 'SCHEDULED':
          return 'Agendada'
        case 'FINISHED':
          return 'Concluída'
        case 'ACTIVE':
          return 'Ativa'
        default:
          return status
      }
    },
    setMousePosition(event) {
      this.showMenu = false
      this.x = event.clientX + 4
      this.y = event.clientY + 4
    },

    showMore(parameters) {
      setTimeout(() => {
        this.clickedDay = DateTime.fromFormat(parameters.date, 'yyyy-MM-dd')
        this.moreCampaigns = this.events.filter((event) => {
          const startDate = DateTime.fromFormat(event.start, 'yyyy-MM-dd')
          const endDate = DateTime.fromFormat(event.end, 'yyyy-MM-dd')
          return startDate <= this.clickedDay && endDate >= this.clickedDay
        })

        this.openMenu({ type: 'more' })
      })
    },

    showCampaign({ nativeEvent, event }) {
      setTimeout(() => {
        if (event.type === 'campaign') {
          this.selectedCampaign = this.campaigns.find((obj) => obj._id === event.id)
        }

        this.openMenu({ type: event.type })
      })
    },

    dayFormat({ day, date }) {
      if (day === 1) {
        const month = capitalize(DateTime.fromISO(date).toFormat('MMM'))
        return `${month}. ${day}`
      }
      return day
    },

    weekdayFormat(day) {
      return capitalize(
        DateTime.fromObject({ weekday: day.weekday === 0 ? 7 : day.weekday })
          .setLocale('pt-BR')
          .toFormat('ccc')
      )
    },

    mensuracaoText({ initialDate, finalDate }) {
      const finalString = DateTime.fromFormat(finalDate, 'yyyy-MM-dd').toFormat('dd/MM/yyyy')
      const initialString = DateTime.fromFormat(initialDate, 'yyyy-MM-dd').toFormat('dd/MM/yyyy')

      return `Mensuração: ${initialString} à ${finalString}`
    },

    openMenu({ type }) {
      this.menuType = type
      this.showMenu = true
    },
    formattedDateRange(start, end) {
      const Start = DateTime.fromFormat(start, 'yyyy-MM-dd')
      const End = DateTime.fromFormat(end, 'yyyy-MM-dd')
      return `${Start.toFormat('dd/MM')} - ${End.toFormat('dd/MM')}`
    },

    getCampaignType(mode) {
      switch (mode) {
        case 'SMS':
          return 'SMS'
        case 'PUSH':
          return 'Push aplicativo'
        case 'EMAIL':
          return 'E-mail'
        case 'WHATSAPP':
          return 'Whatsapp'
        default:
          return 'Campanha da mar.ia'
      }
    },
    getCampaignColor(mode) {
      switch (mode) {
        case 'SMS':
          return '#3498db'
        case 'PUSH':
          return '#8e44ad'
        case 'EMAIL':
          return '#e74c3c'
        case 'WHATSAPP':
          return '#27ae60'
        default:
          return '#FFC700'
      }
    },
    closeMenu() {
      this.showMenu = false
    },
    openRedirectDialog(campaign) {
      this.$confirm({
        title: 'Você está sendo redirecionado',
        message: 'Caso queira continuar, você será redirecionado para a seção da campanha selecionada. Deseja continuar?',
        confirmText: 'Confirmar',
        cancelText: 'Cancelar',
      })
        .then(() => {
          this.$router.push(this.getRedirectUrl(campaign)).catch(() => {})
        })
        .catch(() => {})
    },
    getRedirectUrl(campaign) {
      if (campaign.status === 'FINISHED') {
        return this.getModeUrl(campaign.mode, campaign._id)['results']
      } else if (campaign.status === 'SCHEDULED') {
        return this.getModeUrl(campaign.mode, campaign._id)['edit']
      }
    },
    getModeUrl(mode, id) {
      switch (mode) {
        case 'SMS':
          return { edit: `/campanhas/sms/editar/${id}`, results: `/campanhas/sms/resultados/${id}` }
        case 'PUSH':
          return { edit: `/campanhas/aplicativo/editar/${id}`, results: `/campanhas/aplicativo/resultados/${id}` }
        case 'EMAIL':
          return { edit: `/campanhas/email/${id}`, results: `/campanhas/email/resultados/${id}` }
        case 'WHATSAPP':
          return { edit: `/campanhas/whatsapp/editar/${id}`, results: `/campanhas/whatsapp/resultados/${id}` }
        default:
          return { edit: `/maria/campanha-da-maria/editar/${id}`, results: `/maria/campanha-da-maria/resultados/${id}` }
      }
    },
    openCampaign(event) {
      const campaign = this.campaigns.find((obj) => obj._id === event.id)
      this.selectedCampaign = campaign
      this.openMenu({ type: 'campaign' })
    },
    async getData() {
      this.enabledCampaignModes = ['SMS', 'EMAIL', 'PUSH', 'WHATSAPP']
    },
  },
}
</script>

<style lang="scss">
.v-calendar-weekly__day-label {
  button {
    pointer-events: none;
  }
}
.card-campaign {
  .close-icon {
    cursor: pointer;
  }
  .toolbar {
    user-select: none;
    height: 48px !important;
    border-radius: 4px;
    .v-toolbar__content {
      height: 48px !important;
    }
  }
  .status {
    opacity: 0.5;
    font-size: 14px;
    line-height: 1.25;
    letter-spacing: 0.19px;
    color: $cinza-0;
    margin-bottom: 4px;
  }
  .name {
    opacity: 0.8;
    font-size: 17px;
    font-weight: bold;
    line-height: 1.2;
    letter-spacing: 0.24px;
    color: $cinza-0;
    margin-bottom: 6px;
  }
  .description {
    opacity: 0.8;
    font-size: 14px;
    line-height: 1.25;
    letter-spacing: 0.19px;
    color: $cinza-0;
  }
  .details {
    margin-bottom: 8px;
    span {
      font-size: 14px;
      line-height: 1.25;
      letter-spacing: 0.19px;
      color: $cinza-0;
    }
  }
}
.card-more {
  .close-icon {
    position: absolute;
    right: 5px;
    top: 5px;
    opacity: 0.5;
    cursor: pointer;
  }
  .day-week {
    opacity: 0.5;
    margin-bottom: 8px;
    font-size: 13px;
    line-height: 1.25;
    letter-spacing: 0.19px;
    text-align: center;
  }
  .day-number {
    opacity: 0.8;
    font-size: 24px;
    margin-bottom: 0px;
    font-weight: bold;
    line-height: 1.22;
    letter-spacing: 0.29px;
    text-align: center;
  }
  .campaign {
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    user-select: none;
    transition: all linear 100ms;
    .date-range {
      font-size: 12px;
      color: black;
      opacity: 0.5;
      letter-spacing: 0.18px;
      margin-right: 4px;
    }
    .name {
      font-size: 13px;
      color: black;
      opacity: 0.8;
      letter-spacing: 0.18px;
    }

    &:hover {
      background-color: rgba(0, 0, 0, 0.15);
      border-radius: 4px;
    }
  }
}
.calendario {
  .v-event-more {
    &:hover {
      background-color: rgba(0, 0, 0, 0.15) !important;
      border-radius: 4px;
    }
  }
  .v-calendar-weekly__day,
  .v-calendar-weekly__day-label {
    cursor: default !important;
  }
  .theme--light.v-calendar-weekly .v-calendar-weekly__head-weekday {
    color: rgba(0, 0, 0, 0.5);
  }
  .v-present {
    font-weight: bold;
    color: rgba(0, 0, 0, 0.8);
  }
}
</style>
